import { ReactComponent as ProfileSvg } from '../../assets/icons/profile.svg';

export const ProfileIcon: SvgIcon = (props) => {
    return <ProfileSvg {...props} />;
};
